// extracted by mini-css-extract-plugin
module.exports = {"card":"sso_card__3k5V3","title":"sso_title__wLpUF","desc":"sso_desc__3lzxU"};